import React, { useEffect } from 'react'
import clsx from 'clsx'
import AdvertisersTemplatesField from 'modules/Forms/Account/Create/subcomponents/AdvertisersTemplatesField'
import AdvertiserFieldsExtended from 'modules/Forms/Account/Create/subcomponents/advertiserFieldsExtended'
import { useTranslation } from 'react-i18next'
import { Container, Typography } from 'gu-ui-kit'
import Switch from 'components/Switch'
import { change, formValueSelector, initialize } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const AdvertiserInfoGroup = ({
  form,
  advertiser_info,
  networkType,
  initialValues,
  hideable = false,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const selector = formValueSelector(form)
  const breakpoints = useBreakpoint()

  const { showAdvertisersField = true } = useSelector((state) => ({
    showAdvertisersField: selector(state, 'showAdvertisersField'),
  }))

  useEffect(() => {
    dispatch(initialize(form, initialValues, true))
  }, [showAdvertisersField])

  return (
    <>
      <Container
        display={'flex'}
        flexJustify={'space-between'}
        className={clsx({
          'margin-top-64': !breakpoints.fb,
          'margin-top-48': breakpoints.fb,
          'margin-bottom-40': !hideable || showAdvertisersField,
        })}
      >
        <Typography variant={'Subtitle-30'} component={'h2'}>
          {t('services::forms.shared_fields.advertiser.show_advertisers_field')}
        </Typography>

        {hideable && (
          <Switch
            checked={showAdvertisersField}
            onChange={() =>
              dispatch(
                change(
                  form,
                  'showAdvertisersField',
                  !showAdvertisersField,
                  false,
                  false,
                ),
              )
            }
          />
        )}
      </Container>
      {!!showAdvertisersField && (
        <>
          <AdvertisersTemplatesField
            change={(...values) =>
              dispatch(change(form, ...values, true, true))
            }
          />

          <AdvertiserFieldsExtended
            form={form}
            advertiser_info={advertiser_info}
            networkType={networkType}
          />
        </>
      )}
    </>
  )
}

AdvertiserInfoGroup.propTypes = {
  form: PropTypes.string,
  initialValues: PropTypes.object,
  hideable: PropTypes.bool,
  advertiser_info: PropTypes.object,
  networkType: PropTypes.string,
}

export default AdvertiserInfoGroup
